import { Task } from "twilio-taskrouter";
import merge from "lodash/merge";
import { ErrorCode, ErrorSeverity, FlexSdkError } from "~/modules/error";
import { getLogger, LoggerName } from "~/modules/logger";
import { TaskRouterImpl } from "~/packages/taskrouter/TaskRouterImpl";
import { ContextManager } from "~/modules/contextManager/ContextManager";
import { sendTrackingEvent, getReservationsByTask } from "../../ActionUtils";
import { EVENTS } from "~/modules/analytics/Analytics";
import { AnalyticsImpl } from "~/modules/analytics/AnalyticsImpl";
import { Action } from "~/modules/actions/Action";



export interface SetTaskAttributesOptions {
    mergeExisting?: boolean;
}





















export class SetTaskAttributes implements Action<Promise<Task>> {
    


    #taskSid: string;

    


    #attributes: Record<any, any>;

    


    #setTaskAttributesOptions?: SetTaskAttributesOptions;

    constructor(taskSid: string, attributes: Record<any, any>, setTaskAttributesOptions?: SetTaskAttributesOptions) {
        this.#taskSid = taskSid;
        this.#attributes = attributes;
        this.#setTaskAttributesOptions = setTaskAttributesOptions;
    }

    async run(ctx: {}) {
        const context = ctx as ContextManager;
        const mergeExisting = this.#setTaskAttributesOptions?.mergeExisting || false;
        const taskRouter = context.getInstanceOf(TaskRouterImpl);
        const logger = getLogger(context)(LoggerName.Actions);
        const worker = taskRouter.worker;
        const analytics = context.getInstanceOf(AnalyticsImpl);

        logger.debug(`setTaskAttributes invoked with taskSid: ${this.#taskSid}`);

        if (!worker) {
            const errorMsg = "setTaskAttributes: worker is not initialized";
            logger.error(errorMsg);
            return Promise.reject(new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg));
        }

        const reservations = getReservationsByTask(worker, this.#taskSid);

        if (!reservations.length) {
            const errorMsg = `setTaskAttributes: task for taskSid: ${this.#taskSid} is not found`;
            logger.error(errorMsg);
            sendTrackingEvent(EVENTS.SetTaskAttributesCompleted, analytics, worker, errorMsg);
            return Promise.reject(new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg));
        }

        const task = reservations[0].task;

        try {
            const newAttributes = mergeExisting ? merge(task?.attributes, this.#attributes) : this.#attributes;
            await task.setAttributes(newAttributes);

            sendTrackingEvent(EVENTS.SetTaskAttributesCompleted, analytics, worker);

            return task;
        } catch (error) {
            const errorMsg = `setTaskAttributes: Could not set task attributes: ${error.message}`;
            sendTrackingEvent(EVENTS.SetTaskAttributesCompleted, analytics, worker, errorMsg);
            return Promise.reject(new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg));
        }
    }
}
